type Props = {
  height?: number;
  stroke?: string;
  width?: number;
};

const CreditCardIcon = ({
  height = 24,
  width = 24,
  stroke = 'white'
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 7V18H20V7H4ZM3.81818 5H20.1818C21.186 5 22 5.83947 22 6.875V18.125C22 19.1605 21.186 20 20.1818 20H3.81818C2.81403 20 2 19.1605 2 18.125V6.875C2 5.83947 2.81403 5 3.81818 5Z"
        fill={stroke}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 10C2 9.44772 2.44772 9 3 9H21C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H3C2.44772 11 2 10.5523 2 10Z"
        fill={stroke}
      />
    </svg>
  );
};

export default CreditCardIcon;
